import React from 'react';
import {
    ErrorConfig,
    SimpleWrapperConfig,
    SuspenseLoadConfig,
    LazyLoadConfig,
} from '../schema/ErrorConfig';
import { getBaseErrorHandler } from './getBaseErrorHandler';
import { ErrorToast } from './ErrorToast';

/**
 * @description: Higher Order Component to take care of
 * 1. React Render Tree failures using error boundaries.
 * 2. Suspense load failure, when passed a lazy/suspense component.
 * 3. LazyComponent failure. Uses OWA bundling createLazyComponent component.
 * Pending: add usage docs: https://outlookweb.visualstudio.com/Outlook%20Web/_workitems/edit/89351
 */
export function withToastNetworkErrorHandler<TProps>(
    WrappedComponent: React.ComponentType<TProps>,
    errorConfig: SimpleWrapperConfig
): React.ComponentType<TProps>;
export function withToastNetworkErrorHandler<TProps>(
    WrappedSuspenseComponent:
        | React.LazyExoticComponent<(props: TProps) => JSX.Element>
        | React.LazyExoticComponent<React.ComponentType<any>>,
    errorConfig: SuspenseLoadConfig
): React.ComponentType<TProps>;
export function withToastNetworkErrorHandler<TProps, TModule, TInnerRef, TPlaceHolderRef = void>(
    WrappedComponent: null,
    errorConfig: LazyLoadConfig<TProps, TModule, TInnerRef, TPlaceHolderRef>
): React.ComponentType<TProps>;
export function withToastNetworkErrorHandler<TProps, TModule, TInnerRef, TPlaceHolderRef = void>(
    WrappedComponent:
        | React.ComponentType<TProps>
        | React.LazyExoticComponent<(props: TProps) => JSX.Element>
        | React.LazyExoticComponent<React.ComponentType<any>>
        | null,
    errorConfig: ErrorConfig<TProps, TModule, TInnerRef, TPlaceHolderRef>
): React.ComponentType<TProps> {
    return getBaseErrorHandler(ErrorToast, WrappedComponent, errorConfig);
}
